import { PlanExtra } from '@dtx-company/true-common/src/types/Plan'
import { SUBSCRIPTIONS_URL_V3 } from './migrateSubscriptions'
import {
  SubscriptionV3DataBase,
  SubscriptionV3ResponseBase
} from '../types/subscriptionV3/SubscriptionV3ResponseBase'
import {
  SubscriptionV3PaymentIntentData,
  SubscriptionV3PaymentIntentResponse
} from '../types/subscriptionV3/SubscriptionV3PaymentIntentResponse'
import { subscriptionServiceDateStringToDate } from '../../../utils/misc/subscriptionServiceDateStringToDate'
import { toPlanExtraDetails } from './toPlanExtraDetails'
import { toSubscriptionStatus } from './toSubscriptionStatus'

export const migrateSubscriptionV3ResponseToSubscriptionV3Data = (
  subscription: SubscriptionV3ResponseBase,
  planExtras?: PlanExtra[]
): SubscriptionV3DataBase => {
  return {
    message: subscription.message,
    customerId: subscription.customerId,
    subscriptionId: subscription.subscriptionId,
    planId: subscription.planId,
    subscriptionStatus: toSubscriptionStatus(subscription.subscriptionStatus),
    paymentMethodId: subscription.paymentMethodId || undefined,
    isCurrent: subscription.isCurrent,
    createdAt: subscriptionServiceDateStringToDate(subscription.createdAt, {
      apiName: SUBSCRIPTIONS_URL_V3
    }),
    planExtraDetails: subscription.planExtraDetails
      ? toPlanExtraDetails(subscription.planExtraDetails, planExtras || [])
      : [],
    queuedDowngradePlanId: subscription.queuedDowngradePlanId,
    billingCycleEnd: subscriptionServiceDateStringToDate(subscription.billingCycleEnd, {
      apiName: SUBSCRIPTIONS_URL_V3
    }),
    eligibleForFreeMonth: subscription.eligibleForFreeMonth,
    trialEndAt: subscription.trialEndAt
      ? subscriptionServiceDateStringToDate(subscription.trialEndAt, {
          apiName: SUBSCRIPTIONS_URL_V3
        })
      : undefined,
    cancelAtPeriodEnd: subscription.cancelAtPeriodEnd
  }
}
export const migrateSubscriptionV3PaymentIntentResponseToSubscriptionV3PaymentIntentData = (
  subscription: SubscriptionV3PaymentIntentResponse,
  planExtras?: PlanExtra[]
): SubscriptionV3PaymentIntentData => {
  return {
    ...migrateSubscriptionV3ResponseToSubscriptionV3Data(subscription, planExtras),
    clientSecret: subscription.clientSecret
  }
}
